export enum EventTypeEnum {
  PURCHASED = 'purchased',
  INTERESTED = 'interested',
  REJECTED = 'rejected',
  SET_PURCHASED = 'set_purchased',
  SET_INTERESTED = 'set_interested',
  SET_REJECTED = 'set_rejected',
  USER_FETCHED = 'user_fetched'
}



// WEBPACK FOOTER //
// ./src/app/helpers/event-type.enum.ts